import React from "react";
// Data
import data from "./tracks.json";

import Navigation from "./components/Navigation.js";
import ListToggle from "./components/ListToggle.js";
import { Player } from 'video-react';


// App
class App extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      playing: false,
      currentTrackIndex: 0
    };
    this.handleClick = this.handleClick.bind(this);
    this.playAudio = this.playAudio.bind(this);
    this.pauseAudio = this.pauseAudio.bind(this);
    this.selectTrackNumber = this.selectTrackNumber.bind(this);
  }
  radios = [
    { 'name': 'Radio Plus', 'url': 'https://stream.radio.co/s8cc7a5da4/listen', 'background': 'https://res.cloudinary.com/tutor-me/image/upload/v1585828707/island_news/radio_plus_bvns6x.png' },
    { 'name': 'Top FM', 'url': 'https://onlineradiobox.com/json/mu/topfm/play?platform=web', 'background': 'https://res.cloudinary.com/tutor-me/image/upload/v1585929989/island_news/top_fm_ekxz9s.jpg' },
    { 'name': 'Radio One', 'url': 'https://onlineradiobox.com/json/mu/radioone/play?platform=web', 'background': 'https://res.cloudinary.com/tutor-me/image/upload/v1585930111/island_news/radio_one_lczm0e.png' },
    { 'name': 'NRJ Maurice', 'url': 'https://onlineradiobox.com/json/mu/nrj/play?platform=web', 'background': 'https://res.cloudinary.com/tutor-me/image/upload/v1585930204/island_news/nrj_maurice_koszod.png' },
    { 'name': 'Planet FM', 'url': 'https://onlineradiobox.com/json/mu/planet/play?platform=web', 'background': 'https://res.cloudinary.com/tutor-me/image/upload/v1586162489/island_news/Planet_FM-High-Resolution-logo-transparent_hsdn4f.png' },
    { 'name': 'Best FM', 'url': 'https://mbcmediaserver.mbcradio.tv/hls-live/bestfm/_definst_/liveevent/livestream.m3u8', 'background': 'https://res.cloudinary.com/tutor-me/image/upload/v1586169174/island_news/MBC-Best-FM-Logo-240x150_ltxnjp.jpg' },
    { 'name': 'Radio Maurice', 'url': 'https://mbcmediaserver.mbcradio.tv/hls-live/radiomaurice/_definst_/liveevent/livestream.m3u8', 'background': 'https://res.cloudinary.com/tutor-me/image/upload/v1586169298/island_news/radio-mauritius_tzdfps.jpg' },
    { 'name': 'Taal FM', 'url': 'http://202.123.27.133/hls-live/audio-only/taalfm/_definst_/liveevent/livestream.m3u8', 'background': 'https://res.cloudinary.com/tutor-me/image/upload/v1586169344/island_news/taal-fm-mauritius_e3nyen.jpg' },
    { 'name': 'Music FM', 'url': 'http://edge126.rdsnet.ro:84/profm/music-fm.mp3', 'background': 'https://res.cloudinary.com/tutor-me/image/upload/v1586169452/island_news/musicfm_fhrqfo.png' },
    { 'name': 'Kool FM', 'url': 'http://202.123.27.133/hls-live/audio-only/koolfm/_definst_/liveevent/livestream.m3u8', 'background': 'https://res.cloudinary.com/tutor-me/image/upload/v1586169528/island_news/koolfm3_g59gow.png' },
    //    { 'name': 'Rodrigues FM', 'url': 'https://wazaafm.ice.infomaniak.ch/wazaafm-192.mp3', 'background': 'https://res.cloudinary.com/tutor-me/image/upload/v1586169581/island_news/rodriguesfm_amsm3t.png' },
  ]

  playAudio() {
    this.audioElement.load();
    this.audioElement.play();
  }

  pauseAudio() {
    this.audioElement.pause();
  }

  selectTrackNumber(trackId) {
    this.setState({ currentTrackIndex: trackId, playing: true }, this.playAudio);
  }

  handleClick(e, trackId) {
    console.log('handlClick')
    this.selectTrackNumber(trackId);

    return;
    return;
    switch (e.target.id) {
      case "play":
        this.setState((state, props) => {
          let currentTrackIndex = state.currentTrackIndex;
          if (currentTrackIndex === 0) {
            currentTrackIndex = 1;
          }
          return {
            playing: true,
            currentTrackIndex: currentTrackIndex
          };
        }, this.playAudio);
        break;
      case "pause":
        this.setState({ playing: false }, this.pauseAudio);
        break;
      case "prev":
        this.setState((state, props) => {
          let currentIndex = state.currentTrackIndex - 1;
          if (currentIndex <= 0) {
            return null;
          } else {
            return { playing: true, currentTrackIndex: currentIndex };
          }
        }, this.playAudio);
        break;
      case "next":
        this.setState((state, props) => {
          let currentIndex = state.currentTrackIndex + 1;
          if (currentIndex > data.tracks.length) {
            return null;
          } else {
            return { playing: true, currentTrackIndex: currentIndex };
          }
        }, this.playAudio);
        break;
      default:
        break;
    }
  }

  render() {
    return (
      <div>
        <header className="Header">
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <img src="https://res.cloudinary.com/tutor-me/image/upload/v1585824074/app_icon_qwk6e7.png" height="45px" alt="profile" style={{ marginRight: '10px' }} />
            <label className="centered" style={{ fontSize: '35px' }}> Island News </label>
          </div>
          <Navigation />
          <div id="search" className="Search">
            <input onKeyUp={this.handleKeyUp} onChange={this.handleChange} type="search" placeholder="Search for a title..." value={this.state.searchTerm} />
          </div>
        </header>

        <div style={{ marginTop: '100px' }}>

        </div>
        <TitleList title="Live Radios" url='discover/movie?sort_by=popularity.desc&page=1' handleClick={this.handleClick} radio={this.radios} />

        <audio crossOrigin="anonymous" ref={(audio) => { this.audioElement = audio }} src={this.radios[this.state.currentTrackIndex].url} />


      </div>
    );
    return (
      <div className="App">
        <div
          className="Artwork"
          style={{ backgroundImage: "url(" + data.artwork + ")" }}
        >
          <Controls onClick={this.handleClick} playing={this.state.playing} />
          <audio ref={(audio) => { this.audioElement = audio }} src={"/songs/" + this.state.currentTrackIndex + ".mp3"} />
        </div>
        <TrackList
          currentTrackIndex={this.state.currentTrackIndex}
          selectTrackNumber={this.selectTrackNumber}
        />
        <div className="MusicCredit">Music: <a href="https://www.bensound.com">https://www.bensound.com</a></div>
      </div>
    );
  }
}

class TitleList extends React.Component {
  apiKey = '87dfa1c669eea853da609d4968d294be';
  radio;

  constructor(props) {
    super(props);
    this.radio = props.radio;

    this.state = { data: [], mounted: false, radio: props.radio, trackId: 0 };
    this.onClick = this.onClick.bind(this);
  }

  loadContent() {

  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.url !== this.props.url && nextProps.url !== '') {
      this.setState({ mounted: true, url: nextProps.url }, () => {
        this.loadContent();
      });
    }
  }

  componentDidMount() {
    if (this.props.url !== '') {
      this.loadContent();
      this.setState({ mounted: true });
    }
  }

  onClick = (e, id) => {
    this.props.handleClick(e, id)
  }

  render() {
    var titles = '';
    // this.radio.forEach((radio) => {
    //   console.log(radio);
    // });

    if (this.state.radio != null) {

      titles = this.state.radio.map(function (title, i) {

        if (i < this.state.radio.length) {
          var backDrop = this.state.radio[i].background;
          var name = this.state.radio[i].name;

          return (
            <Item onClick={() => {

              this.onClick(this, i)
            }} key={name} title={name} backdrop={backDrop} />

          );
        } else {
          return (<div></div>);
        }
      }, this);
    }

    return (
      <div ref="titlecategory" className="TitleList" data-loaded={this.state.mounted}>
        <div className="Title">
          <h1>{this.props.title}</h1>
          <div className="titles-wrapper">
            {titles}
          </div>
        </div>
      </div>
    );
  }
}

class Item extends React.Component {

  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }


  onClick = () => {
    this.props.onClick()
  }

  render() {
    return (
      <div onClick={this.onClick} className="Item" style={{ backgroundImage: 'url(' + this.props.backdrop + ')' }} >
        <div className="overlay">
          <div className="title">{this.props.title}</div>
        </div>
      </div>
    );
  }
}

// Controls
class Controls extends React.Component {
  render() {
    return (
      <div className="Controls">
        <i
          id="prev"
          className="fa fa-fw fa-fast-backward"
          onClick={this.props.onClick}
        />
        {!this.props.playing &&
          <i
            id="play"
            onClick={this.props.onClick}
            className="fa fa-fw fa-play"
          />}
        {this.props.playing &&
          <i
            id="pause"
            onClick={this.props.onClick}
            className="fa fa-fw fa-pause"
          />}
        <i
          id="next"
          className="fa fa-fw fa-fast-forward"
          onClick={this.props.onClick}
        />
      </div>
    );
  }
}

// TrackList
class TrackList extends React.Component {
  constructor(props) {
    super(props);
    this.state = { tracks: [] }
    this.renderListItem = this.renderListItem.bind(this);
  }
  componentDidUpdate() {
    if (this.activeTrack) {
      let topOfTrackList = this.trackList.scrollTop;
      let bottomOfTrackList =
        this.trackList.scrollTop + this.trackList.clientHeight;
      let positionOfSelected = this.activeTrack.offsetTop;
      if (
        topOfTrackList > positionOfSelected ||
        bottomOfTrackList < positionOfSelected
      ) {
        this.trackList.scrollTop = positionOfSelected;
      }
    }
  }
  componentDidMount() {
    //fetch data for a track here (i.e. from Spotify or Soundcloud)s
    this.setState({ tracks: data.tracks });
  }

  renderListItem(track, i) {
    let trackClass = this.props.currentTrackIndex === track.id
      ? "selected"
      : "";
    return (
      <li
        key={track.id}
        className={trackClass}
        ref={cur => {
          if (this.props.currentTrackIndex === track.id) {
            this.activeTrack = cur;
          }
        }}
        onClick={() => { this.props.selectTrackNumber(track.id) }}
      >
        <div className="number">{track.id}</div>
        <div className="title">{track.title}</div>
        <div className="duration">{track.duration}</div>
      </li>
    );
  }
  render() {
    let tracks = this.state.tracks.map(this.renderListItem);
    return (
      <ul
        className="TrackList"
        ref={input => {
          this.trackList = input;
        }}
      >
        {tracks}
      </ul>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js